import { WhatsappLogo } from "@phosphor-icons/react";
import { WHATSAPP } from "../data";

export const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(
    "Hi DS CABS! I'd like to book a ride/delivery."
  )}`;
  return (
    <a
      data-testid="whatsapp-float"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-[60] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] border-2 border-ink shadow-[4px_4px_0_0_#0A0A0A] group-hover:translate-x-[2px] group-hover:translate-y-[2px] group-hover:shadow-none transition-all duration-150">
        <WhatsappLogo weight="fill" size={30} className="text-white" />
      </span>
    </a>
  );
};
